var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "main-row" },
    [
      _vm.mdAndUp
        ? _c(
            "v-col",
            {
              staticClass: "context-row",
              attrs: { xl: "2", lg: "3", md: "3" },
            },
            [_c("context", { attrs: { page: "Vendor Address Book" } })],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        {
          staticClass: "about-col address-book-col bg-white",
          attrs: { xl: "10", lg: "9", md: "9", sm: "12" },
        },
        [
          _c(
            "v-container",
            { staticClass: "grow d-flex flex-column flex-nowrap" },
            [
              _c(
                "v-row",
                {
                  staticClass: "address-book-row shrink",
                  class: { "pt-10 px-16": _vm.mdAndUp, "px-4": _vm.smAndDown },
                },
                [
                  _c("v-col", { staticClass: "pl0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "header-lbl" }, [
                      _vm._v("Vendor Address Book"),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl0 search-bar-wrapper",
                      class: { pr0: _vm.smAndDown },
                      attrs: {
                        cols: "12",
                        xl: "7",
                        lg: "7",
                        md: "8",
                        sm: "12",
                      },
                    },
                    [
                      _c("smart-text-field", {
                        directives: [
                          {
                            name: "debounce",
                            rawName: "v-debounce:300ms",
                            value: _vm.searchWithReset,
                            expression: "searchWithReset",
                            arg: "300ms",
                          },
                        ],
                        attrs: {
                          placeholder: "Search",
                          search: true,
                          clearable: true,
                          "char-delay": 3,
                          "css-class": { "mt-2": _vm.mdAndUp },
                        },
                        on: {
                          clear: _vm.onClear,
                          "enter-pressed": function ($event) {
                            return _vm.searchWithReset()
                          },
                        },
                        model: {
                          value: _vm.term,
                          callback: function ($$v) {
                            _vm.term = $$v
                          },
                          expression: "term",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                {
                  staticClass: "shrink mt-0",
                  class: { "px-16": _vm.mdAndUp, "px-4 pt-0": _vm.smAndDown },
                  attrs: { justify: "end" },
                },
                [
                  _c(
                    "v-col",
                    {
                      class: { "pt-0": _vm.smAndDown },
                      attrs: {
                        xs: "12",
                        sm: "12",
                        md: "12",
                        lg: "12",
                        xl: "12",
                      },
                    },
                    [
                      _c("smart-btn", {
                        class: {
                          "fr ml-5": _vm.lg || _vm.md || _vm.xl,
                          "w-100-pct": _vm.smAndDown,
                        },
                        attrs: {
                          type: "primary",
                          label: "New Address",
                          "icon-width": "12",
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          icon: _vm.ic_plus,
                        },
                        on: { click: _vm.openAddNewAddressForm },
                      }),
                      _c("smart-btn", {
                        staticClass: "ta-r fr export-csv-btn",
                        class: { "w-100-pct mt-2": _vm.smAndDown },
                        attrs: {
                          label: "Export CSV",
                          icon: _vm.exportLoading
                            ? _vm.ic_loader
                            : _vm.ic_export_icon,
                          "icon-width": "12",
                          "icon-position": "left",
                          "icon-class": "mr-2",
                          bg: "white",
                          border: "navy-blue",
                          font: "navy-blue",
                          disabled: _vm.exportLoading,
                          loading: _vm.exportLoading,
                        },
                        on: { click: _vm.exportCsv },
                      }),
                    ],
                    1
                  ),
                  _vm.showDataGrid
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-10 br-8 align-top-all-rows" },
                            [
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.page,
                                  "hide-default-footer": true,
                                  loading: _vm.loading,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.id",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "v-menu",
                                            {
                                              staticClass: "address-menu",
                                              attrs: { bottom: "", left: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "close-btn base",
                                                                attrs: {
                                                                  icon: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.displayFilters = false
                                                                    },
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            !_vm.editing ||
                                                            _vm.currentAddressId !==
                                                              item.id
                                                              ? _c("img", {
                                                                  attrs: {
                                                                    src: _vm.ic_slim_dots,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm.editing &&
                                                            _vm.currentAddressId ==
                                                              item.id
                                                              ? _c("img", {
                                                                  attrs: {
                                                                    width: "34",
                                                                    src: _vm.ic_loader,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                { staticClass: "w-140" },
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass:
                                                        "user-action",
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "h-60 menu-element",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.edit(
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-layout",
                                                            {
                                                              staticClass:
                                                                "mt-5",
                                                            },
                                                            [
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  staticClass:
                                                                    "mt_2 pr-8",
                                                                  attrs: {
                                                                    xs2: "",
                                                                    sm2: "",
                                                                    md2: "",
                                                                    lg2: "",
                                                                    xl2: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm.ic_pencil,
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    xs10: "",
                                                                    sm10: "",
                                                                    md10: "",
                                                                    lg10: "",
                                                                    xl10: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "edit-lbl",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Edit"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass:
                                                        "user-action",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmDelete(
                                                            item.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "h-60 menu-element",
                                                        },
                                                        [
                                                          _c(
                                                            "v-layout",
                                                            {
                                                              staticClass:
                                                                "mt-5",
                                                            },
                                                            [
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  staticClass:
                                                                    "mt_2 pr-8",
                                                                  attrs: {
                                                                    xs2: "",
                                                                    sm2: "",
                                                                    md2: "",
                                                                    lg2: "",
                                                                    xl2: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "mr-5",
                                                                    attrs: {
                                                                      src: _vm.ic_delete,
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    xs10: "",
                                                                    sm10: "",
                                                                    md10: "",
                                                                    lg10: "",
                                                                    xl10: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "delete-lbl",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Delete"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.contact",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "label",
                                            { staticClass: "t-text" },
                                            [_vm._v(_vm._s(item.contact))]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.phone",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "label",
                                            { staticClass: "t-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPhone(item.phone)
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.typeId",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "label",
                                            { staticClass: "t-addr-type" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getTypeDesc(item.typeId)
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.location",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "label",
                                            { staticClass: "t-text" },
                                            [
                                              _vm._v(
                                                _vm._s(item.company) +
                                                  " - " +
                                                  _vm._s(item.address1) +
                                                  ", " +
                                                  _vm._s(item.city) +
                                                  " " +
                                                  _vm._s(item.state) +
                                                  " " +
                                                  _vm._s(item.postalCode) +
                                                  " " +
                                                  _vm._s(item.country)
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.email",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "label",
                                            { staticClass: "t-text" },
                                            [_vm._v(_vm._s(item.email))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1313352859
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showNoData
                    ? _c(
                        "v-col",
                        { staticClass: "ta-c mt-10", attrs: { cols: "12" } },
                        [_c("no-data")],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.showPaging
                ? _c(
                    "v-row",
                    { staticClass: "mt-n4", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pagination-numbers",
                            attrs: {
                              length: Math.ceil(_vm.totalCount / _vm.pageSize),
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ta-c mt-n3 mb-3",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { justify: "center" } },
                            [
                              _c("v-col", { attrs: { cols: "auto" } }, [
                                _c(
                                  "label",
                                  { staticClass: "page-label ta-c db" },
                                  [_vm._v(_vm._s(this.entryCount))]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "546px" },
              model: {
                value: _vm.displayConfirmDelete,
                callback: function ($$v) {
                  _vm.displayConfirmDelete = $$v
                },
                expression: "displayConfirmDelete",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "br-10" },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "py-10 px-10 ta-c",
                          attrs: { row: "", wrap: "" },
                        },
                        [
                          _c("v-flex", [
                            _c("label", { staticClass: "are-your-sure-lbl" }, [
                              _vm._v(
                                "Are you sure you want to delete address? This cannot be undone!"
                              ),
                            ]),
                          ]),
                          _c("v-flex", { staticClass: "mt-6" }, [
                            _c("label", { staticClass: "delete-label" }, [
                              _vm._v(
                                "Deleting this address will remove all information from our database."
                              ),
                            ]),
                          ]),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-layout",
                                { staticClass: "mt-12 mb-2" },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("smart-btn", {
                                        staticClass: "fr mr-4",
                                        attrs: {
                                          type: "dismiss",
                                          label: "Cancel",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.displayConfirmDelete = false
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    [
                                      _c("smart-btn", {
                                        staticClass: "fl ml-4",
                                        attrs: {
                                          type: "danger",
                                          label: "Delete",
                                          loading: _vm.deleting,
                                        },
                                        on: { click: _vm.softDeleteAddress },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                scrollable: "",
                eager: true,
                width: _vm.addEditDialogWidth,
              },
              model: {
                value: _vm.displayAddressForm,
                callback: function ($$v) {
                  _vm.displayAddressForm = $$v
                },
                expression: "displayAddressForm",
              },
            },
            [
              _c("add-edit-address-form", {
                on: {
                  close: function ($event) {
                    _vm.displayAddressForm = false
                  },
                  closeAndReload: _vm.closeAndReload,
                },
              }),
            ],
            1
          ),
          _c(
            "v-snackbar",
            {
              attrs: { timeout: 3000, top: "" },
              scopedSlots: _vm._u([
                {
                  key: "action",
                  fn: function (ref) {
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._b(
                          {
                            attrs: { color: "blue", text: "" },
                            on: {
                              click: function ($event) {
                                _vm.snackbar = false
                              },
                            },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        [_vm._v(" Close ")]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }